@if (showLanguageSelection) {
  <app-screen-shell [contentClass]="'public-entry-shell claim-language-page'" layout="public-entry" variant="public" [showHeader]="false">
    <section class="claim-language-panel">
      <img class="claim-language-logo" src="assets/images/footballer-zone-logo-transparent.png" alt="Footballer.zone">
      <h1 id="claim-language-title">{{ 'splashLanguage.dropdownTitle' | translate }}</h1>

      <div class="claim-language-options" role="radiogroup" [attr.aria-label]="'splashLanguage.dropdownTitle' | translate">
        <button
          type="button"
          class="claim-language-option"
          role="radio"
          [class.selected]="isSelectedLanguage('en')"
          [attr.aria-checked]="isSelectedLanguage('en')"
          (click)="selectLanguage('en')">
          <span class="claim-language-option-label">
            <span class="claim-language-flag" aria-hidden="true">🇬🇧</span>
            <span>{{ 'languages.en' | translate }}</span>
          </span>
          @if (isSelectedLanguage('en')) {
            <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
          }
        </button>
        <button
          type="button"
          class="claim-language-option"
          role="radio"
          [class.selected]="isSelectedLanguage('hr')"
          [attr.aria-checked]="isSelectedLanguage('hr')"
          (click)="selectLanguage('hr')">
          <span class="claim-language-option-label">
            <span class="claim-language-flag" aria-hidden="true">🇭🇷</span>
            <span>{{ 'languages.hr' | translate }}</span>
          </span>
          @if (isSelectedLanguage('hr')) {
            <i [class]="'common.check' | nogoshIcon" aria-hidden="true"></i>
          }
        </button>
      </div>
    </section>
  </app-screen-shell>
}

@if (!showLanguageSelection) {
<app-screen-shell
  [contentClass]="'public-claim-page'"
  variant="public"
  titleKey="guestClaim.claimTitle"
  [loading]="loadingVisible"
  loadingTitleKey="common.loadingData"
  [hideContentWhileLoading]="true">
  <div class="profile-content-width mx-auto">
    <div class="card">
      <div class="card-body px-3 py-4">
        @if ((claimReady$ | async) && errorMsg) {
          <div class="alert alert-danger" role="alert">
            <p class="mb-1">{{errorMsg}}</p>
            @if (diagnosticMsg) {
              <p class="mb-0 text-sm">{{diagnosticMsg}}</p>
            }
          </div>
        }
        @if ((claimReady$ | async) && message) {
          <div class="alert alert-success" role="alert">{{message}}</div>
        }
        @if ((claimReady$ | async) && emailNotVerified) {
          <div class="alert alert-warning" role="alert">
            <p class="mb-2">{{ 'guestClaim.emailNotVerified.description' | translate }}</p>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              [disabled]="emailVerificationInProgress"
              (click)="sendVerificationEmail()">
              @if (emailVerificationInProgress) {
                <app-delayed-indicator></app-delayed-indicator>
              }
              {{ 'guestClaim.emailNotVerified.sendVerification' | translate }}
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm ml-2"
              [disabled]="claimInProgress || emailVerificationInProgress"
              (click)="claimProfile()">
              {{ 'common.tryAgain' | translate }}
            </button>
          </div>
        }
        @if ((claimReady$ | async) && emailVerificationSent) {
          <div class="alert alert-success" role="alert">
            {{ 'guestClaim.emailNotVerified.sent' | translate }}
          </div>
        }

        @if ((claimReady$ | async) && claimInfo && claimInfo.valid && !message) {
          <div>
            <h1 class="h4 mb-3">{{ 'guestClaim.claimProfile' | translate }}</h1>
            <div class="players-list border-bottom border-bottom-not-last py-2">
              <p class="h6 pb-0 mb-0">{{ 'common.name' | translate }}</p>
              <p class="text-nogosh-grey3 mb-0">{{claimInfo.name}}</p>
            </div>
            <div class="players-list border-bottom border-bottom-not-last py-2">
              <p class="h6 pb-0 mb-0">{{ 'common.nickname' | translate }}</p>
              <p class="text-nogosh-grey3 mb-0">{{claimInfo.nickName}}</p>
            </div>
            <div class="players-list py-2">
              <p class="h6 pb-0 mb-0">{{ 'players.guestClaimExpiresAt' | translate }}</p>
              <p class="text-nogosh-grey3 mb-0">{{claimInfo.expiresAt}}</p>
            </div>
            @if (!isAuthenticated) {
              <button type="button" class="btn btn-primary btn-block mt-3" (click)="login()">{{ 'guestClaim.loginOrSignUp' | translate }}</button>
            }
            @if (isAuthenticated) {
              <button type="button" class="btn btn-primary btn-block mt-3" [disabled]="claimInProgress" (click)="claimProfile()">{{ 'guestClaim.claimProfile' | translate }}</button>
            }
          </div>
        }
      </div>
    </div>
  </div>
</app-screen-shell>
}
